export default __webpack_public_path__ + "img/img_ed-6abfbf16da93fb29649180238be1aad3.jpg";